import Loading from '../../../Common/Loading';
import { useBirthChartsDataContext } from './hooks/useBirthChartsDataContext';
import { OccurrenceLocation } from './OccurrenceLocation';
import { Labor } from './Labor';
import { Presentation } from './Presentation';
import { CesareansBeforeBirthStart } from './CesareansBeforeBirthStart';
import { TypeOfBirth } from './TypeOfBirth';
import { AssistedBirth } from './AssistedBirth';

export const Charts = () => {
    const { isLoading } = useBirthChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <OccurrenceLocation />
                <Labor />
            </div>
            <div className="charts-side-by-side-dashboards">
                <Presentation />
                <CesareansBeforeBirthStart />
            </div>
            <div className="charts-side-by-side-dashboards">
                <TypeOfBirth />
                <AssistedBirth />
            </div>
        </>
    );
};
